/*

	NOTICE!
	This file was generated automatically
	This is not code!

*/

import { EventType } from 'Utility/Helpers/Events/EventType';
import { PopupID } from 'State/UI/PopupID';
import { EasterFTUXLayout } from 'Layouts/Events/easter_2025/eventFTUX/EasterFTUXLayout';
import { EasterEventOfferLayout } from 'Layouts/Events/easter_2025/eventOfferPopup/EasterEventOfferLayout';
import { EasterEventFieldHarvestLayout } from 'Layouts/Events/easter_2025/fieldHarvestMenu/EasterEventFieldHarvestLayout';
import { EasterEventLevelCompletePopupLayout } from 'Layouts/Events/easter_2025/levelCompletePopup/EasterEventLevelCompletePopupLayout';
import { EasterEventLevelPopupLayout } from 'Layouts/Events/easter_2025/levelPopup/EasterEventLevelPopupLayout';
import { EasterEventLevelPopupSideMenuLayout } from 'Layouts/Events/easter_2025/levelPopupSideMenu/EasterEventLevelPopupSideMenuLayout';
import { EasterPlinkoMinigameLayout } from 'Layouts/Events/easter_2025/plinkoMiniGame/EasterPlinkoMinigameLayout';
import { EasterEventQuestsPopupLayout } from 'Layouts/Events/easter_2025/questsMenu/EasterEventQuestsPopupLayout';

export const EventLayoutMap: Partial<Record<EventType, Partial<{[key in PopupID]: any}>>> = {
    ['easter_2025']: {

    ['eventFTUX']: EasterFTUXLayout,
    ['eventOfferPopup']: EasterEventOfferLayout,
    ['fieldHarvestMenu']: EasterEventFieldHarvestLayout,
    ['levelCompletePopup']: EasterEventLevelCompletePopupLayout,
    ['levelPopup']: EasterEventLevelPopupLayout,
    ['levelPopupSideMenu']: EasterEventLevelPopupSideMenuLayout,
    ['plinkoMiniGame']: EasterPlinkoMinigameLayout,
    ['questsMenu']: EasterEventQuestsPopupLayout,
}
,
}
